import { AppEnv } from '@nexelem/api';

export const getEnvName = (appEnv: AppEnv): Exclude<keyof typeof AppEnv | '', 'prod'> => {
  const entries = Object.entries(AppEnv) as [keyof typeof AppEnv, AppEnv][];

  const envName = entries.find(([, value]) => value === appEnv)?.[0];

  if (envName === 'prod' || envName === undefined) {
    return '';
  }

  return envName;
};
